// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__37yJl","calendarButtons":"ClockData_calendarButtons__3UWkl"};